import{
    GET_NOTIFICATIONS,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAIL,
    GET_UNREAD_NOTIFICATIONS,
    GET_UNREAD_NOTIFICATIONS_SUCCESS,
    GET_UNREAD_NOTIFICATIONS_FAIL,
    DELETE_ALL_NOTIFICATIONS,
    DELETE_ALL_NOTIFICATIONS_SUCCESS,
    DELETE_ALL_NOTIFICATIONS_FAIL,
    DELETE_NOTIFICATION,
    DELETE_NOTIFICATION_SUCCESS,
    DELETE_NOTIFICATION_FAIL,
    MARK_AS_READ,
    MARK_AS_READ_SUCCESS,
    MARK_AS_READ_FAIL,


} from './actionTypes'

const INIT_STATE = {
    notifications: [],
    unreadnotifications: [],
    isLoading: false, 
    error: null,
  };

const NotificationsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
      case GET_NOTIFICATIONS:
        return {
          ...state,
            isLoading: true,
        };
      case GET_NOTIFICATIONS_SUCCESS:
        return {
            ...state,
            notifications: action.payload,
            isLoading: false,
            };
      case GET_NOTIFICATIONS_FAIL:
            return {
            ...state,
            error: action.payload,
            };
      case GET_UNREAD_NOTIFICATIONS:
        return {
          ...state,
            isLoading: true,
        };
      case GET_UNREAD_NOTIFICATIONS_SUCCESS:
        return {
            ...state,
            unreadnotifications: action.payload,
            isLoading: false,
            };
      case GET_UNREAD_NOTIFICATIONS_FAIL:
            return {
            ...state,
            error: action.payload,
            };
       case DELETE_ALL_NOTIFICATIONS:
          
        return {
          ...state,
            isLoading: true,
        };
      case DELETE_ALL_NOTIFICATIONS_SUCCESS:
        return {

            ...state,
            notifications: action.payload,
            isLoading: false,
            };
      case DELETE_ALL_NOTIFICATIONS_FAIL:
            
            return {
            ...state,
            error: action.payload,
            };
      case DELETE_NOTIFICATION:
        return {
          ...state,

            isLoading: true,
        };
      case DELETE_NOTIFICATION_SUCCESS:
        return {

            ...state,
            notifications: state.notifications.filter(
              notification => notification.id !== action.payload.id
          ),
            // notifications: action.payload,
            isLoading: false,
            };
      case DELETE_NOTIFICATION_FAIL:
          return{
            ...state,
            error: action.payload,

          };
       case MARK_AS_READ:
        return {
          ...state,
            isLoading: true,
        };

      case MARK_AS_READ_SUCCESS:
        return {
          ...state,
          // notifications: action.payload,
          unreadnotifications: state.unreadnotifications.filter(
            notification => notification.id !== action.payload.id
        ),

          isLoading: false,
        };
      case MARK_AS_READ_FAIL:
        return {
          ...state,
          error: action.payload,
        };

        default:
            return state;
        }
    }

 export default NotificationsReducer;   